import { render, staticRenderFns } from "./EditReseller.vue?vue&type=template&id=04b93c9f"
import script from "./EditReseller.vue?vue&type=script&lang=js"
export * from "./EditReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports